export enum AttachmentConfType {
  STATIC = "STATIC",
  DYNAMIC = "DYNAMIC",
  PROVIDED = "PROVIDED",
}
